<template>
    <div class="about wrapper col" :style="conditionalPadding">
        <Logo class="logo"/>
        <h1><span class="logotype">monroe</span> is a place to have <span class="nowrap theme-color">trade shows</span> online.</h1>
        <div class="column-3">
            <div>
                <Beverage class="icon"/>
                <h2>The perks of an in-person trade show:</h2>
            </div>
            <h3 class="r2">Tap someone on the shoulder and have a quick chat, just like you're in the same room.</h3>
            <div>
                <Conversation class="icon"/>
                <h2>With genuine social interaction:</h2>
            </div>
            <h3 class="r2">Get people to actually stick around at your event after the speaker is finished.</h3>
            <div>
                <Magic class="icon"/>
                <h2>And all the magic of online events:</h2>
            </div>
            <h3 class="r2">Use our AI recommendations to network more effectively and meet thousands of exhibitors.</h3>
        </div>
        <br>

        <br>
        <div>
            <LargeButton
                @click="$router.push('/expo/eicma')"
                text="Try our demo"
            />
        </div>
        <Footer/>
    </div>
</template>

<script>
import Logo from '../assets/logo.svg'
import Beverage from '../assets/icon/beverage.svg'
import Magic from '../assets/icon/magic.svg'
import Conversation from '../assets/icon/conversation.svg'

import Footer from './Footer'

export default {
    name: 'About',
    components: {
        Logo, Beverage, Magic, Conversation,
        Footer
    },
    computed: {
        conditionalPadding() {
            return {
                paddingTop: this.$route.name == 'About' ? '140px' : '60px'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../interface.scss';

.logo {
    height: 200px;
}

.logotype {
    font-size: 51px;
    margin-right: 8px;
}

.about {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}
.icon {
    height: 80px;
    margin: 10px;
}

.column-3 {
    grid-template-columns: repeat(3, 1fr);
    column-gap: 30px;
    .r2 {
        grid-row: 2;
    }
}
@media screen and (min-width: 1200px){
    .column-3 {
        display: grid;
    }    
}
</style>